import { render, staticRenderFns } from "./InputPieceSh.vue?vue&type=template&id=0cd135db&scoped=true"
import script from "./InputPieceSh.vue?vue&type=script&lang=js"
export * from "./InputPieceSh.vue?vue&type=script&lang=js"
import style0 from "./InputPieceSh.vue?vue&type=style&index=0&id=0cd135db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd135db",
  null
  
)

export default component.exports